module.exports = __webpack_public_path__ + "img/fw.60f223c5.png";